export default __webpack_public_path__ + "static/media/icon-dedicated-server.ea4e7efe.svg";